'use strict';

// http://www.ecma-international.org/ecma-262/5.1/#sec-9.11

module.exports = require('is-callable');



//////////////////
// WEBPACK FOOTER
// ./~/array.prototype.find/~/es-abstract/2019/IsCallable.js
// module id = 231
// module chunks = 3